module.exports = __webpack_public_path__ + "static/media/IconSearch.0171c261.svg";